// معنی عددهای CouponTargetType طبق بکند:
// 1 همه‌چیز (عمومی)، 2 فقط یک استاد خاص، 3 فقط یک درس خاص، 4 فقط یک پکیج خاص،
// 5 فقط پکیج پشتیبانی ساعتی (مورد خاصی برای انتخاب ندارد)
export const COUPON_TARGET = {
  all: 1,
  master: 2,
  lesson: 3,
  package: 4,
  supportLesson: 5,
};

export const COUPON_TARGET_LABELS = {
  [COUPON_TARGET.all]: "همه‌ی موارد",
  [COUPON_TARGET.master]: "استاد خصوصی",
  [COUPON_TARGET.lesson]: "درس",
  [COUPON_TARGET.package]: "پکیج",
  [COUPON_TARGET.supportLesson]: "پشتیبانی ساعتی",
};
